<div class="bg-dark min-h-screen">
  <div class="container mx-auto px-4 py-16 text-light">
    <div class="max-w-3xl mx-auto">
      <h1 class="text-4xl md:text-5xl font-bold mb-6 text-primary text-center">Contacteer Ons</h1>
      <p class="text-lg md:text-xl mb-12 text-center text-gray-300">
        Heeft u vragen of opmerkingen? Neem gerust contact met ons op.
      </p>

      <div class="grid md:grid-cols-2 gap-8 mb-12">
        <!-- Email Card -->
        <div class="bg-dark-light p-8 rounded-lg border border-light/10 hover:border-primary/50 transition-all duration-300">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-light">E-mail</h3>
          </div>
          <a href="mailto:info@kansinonederland.com" class="text-primary hover:text-orange-600 transition-colors">
            info@kansinonederland.com
          </a>
        </div>

        <!-- Website Card -->
        <div class="bg-dark-light p-8 rounded-lg border border-light/10 hover:border-primary/50 transition-all duration-300">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-light">Website</h3>
          </div>
          <a href="https://kansinonederland.com" target="_blank" rel="noopener" class="text-primary hover:text-orange-600 transition-colors">
            kansinonederland.com
          </a>
        </div>
      </div>

      <!-- Additional Info -->
      <div class="bg-dark-light p-8 rounded-lg border border-light/10">
        <h3 class="text-2xl font-semibold mb-4 text-light">Reactietijd</h3>
        <p class="text-gray-300 mb-4">
          We streven ernaar om binnen 24 uur te reageren op alle vragen en opmerkingen.
        </p>
        <div class="flex items-center text-accent">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span>Maandag - Vrijdag: 9:00 - 18:00</span>
        </div>
      </div>
    </div>
  </div>
</div>

